export interface ShowcaseScreen {
  src: string;
  alt: string;
}

export interface ShowcaseItem {
  id: string;
  eyebrow: string;
  title: string;
  description: string;
  points: string[];
  screens: ShowcaseScreen[];
}

export const SHOWCASE: ShowcaseItem[] = [
  {
    id: "talk",
    eyebrow: "Talk",
    title: "A voice for every word",
    description: "Build your child a talking board from clear, friendly symbols. They tap, SENfully speaks, and the words they need are always one tap away.",
    points: ["About 3,000 symbols, or a starter set of twelve", "Build a sentence and hear it read out in turn", "Keeps working offline, with a child lock to stay on the board"],
    screens: [
      { src: "/screens/board.jpg", alt: "A child's SENfully board with picture words and a sentence being built along the top" },
      { src: "/screens/words.jpg", alt: "The SENfully Words page, where a parent chooses the words on their child's board" },
    ],
  },
  {
    id: "profile",
    eyebrow: "All about them",
    title: "Everything that helps, in one place",
    description: "Write down what helps your child, what's hard and how they communicate, once. Then share it with the people who need it.",
    points: ["Sections in your child's own voice, from routines to interests", "Choose which parts each family member can see", "Make a one-page PDF for school, a carer or a meeting"],
    screens: [
      { src: "/screens/child-profile.jpg", alt: "A child's SENfully profile with what helps and what's difficult" },
      { src: "/screens/share-profile.jpg", alt: "Choosing the sections to include in a child's printable profile" },
    ],
  },
  {
    id: "dates",
    eyebrow: "Key dates",
    title: "Never miss the meeting that matters",
    description: "Annual reviews, appointments and deadlines all live on one calendar, with reminders sent to whoever needs them.",
    points: ["A month view with what's coming up next", "Reminders from an hour to four weeks before", "Send a reminder to yourself, your partner or a grandparent"],
    screens: [
      { src: "/screens/key-dates.jpg", alt: "The SENfully key dates calendar with an annual review coming up" },
      { src: "/screens/home.jpg", alt: "The SENfully home screen" },
    ],
  },
  {
    id: "family",
    eyebrow: "Family",
    title: "Everyone who loves them, on the same page",
    description: "Bring parents, grandparents and trusted carers into one private family, with a feed for the everyday news and the big wins.",
    points: ["Post updates and photos only your family can see", "Tag a child, or attach a guide that helped", "Decide what each person can see of every profile"],
    screens: [
      { src: "/screens/family-feed.jpg", alt: "The SENfully family feed with updates from a parent and a grandparent" },
      { src: "/screens/family-members.jpg", alt: "The SENfully family settings listing parents and family members" },
    ],
  },
  {
    id: "guides",
    eyebrow: "SEND guides",
    title: "Clear answers to the confusing bits",
    description: "Plain-English guides to EHCPs, school support, benefits and your rights, matched to the nation you live in.",
    points: ["Guides for England, Scotland, Wales and Northern Ireland", "Links to the official sources behind each one", "Attach a guide to a family post to share what helped"],
    screens: [
      { src: "/screens/send-hub.jpg", alt: "The SENfully SEND guides library" },
      { src: "/screens/send-article.jpg", alt: "A SENfully guide explaining an EHCP needs assessment" },
    ],
  },
  {
    id: "charlie",
    eyebrow: "Charlie",
    title: "Ask, or just say it out loud",
    description: "Charlie is SENfully's friendly helper for the confusing bits. Type a question, or tap the mic and talk, and Charlie answers from our checked SEND guides.",
    points: ["Answers from checked guides, with the sources shown", "Talk and listen, and Charlie reads the answer aloud", "General information, never medical or legal advice"],
    screens: [
      { src: "/screens/charlie-chat.jpg", alt: "Charlie answering a question about asking for an EHC needs assessment, with the guides it used" },
      { src: "/screens/charlie-voice.jpg", alt: "Talking to Charlie: the friendly Charlie character in a glowing circle, reading an answer aloud" },
    ],
  },
  {
    id: "community",
    eyebrow: "Community",
    title: "Families who get it",
    description: "Ask a question, share what worked, or just say it's been a hard day, to other families on the same road.",
    points: ["Post under a community name you choose", "Questions, tips, wins and support, each easy to find", "Make friends and message them privately, if you want to"],
    screens: [
      { src: "/screens/community.jpg", alt: "The SENfully community feed with questions and tips from other families" },
      { src: "/screens/messages.jpg", alt: "A private message conversation between two SENfully families" },
    ],
  },
];
